import Vue from "vue";

import HomePage from "@/pages/home.page";
import ResourcesPage from "@/pages/resources.page";
import NetworkingPage from "@/pages/networking.page";
import SignUpPage from "@/pages/signup.page";
import SignUpThanksPage from "@/pages/signup-thanks.page";
import MemoriesPage from "@/pages/memories.page";
import AgendaPage from "@/pages/agenda.page";
import ArticlePage from "@/pages/article.page";
import ChatTestPage from "@/pages/chat-test.page";
import ChatHubPage from "@/pages/chat-hub.page";
import SocialsPage from "@/pages/socials.page";
import ChatIndexPage from "@/pages/chat-index.page";
import LoginPage from "@/pages/login.page";
import ForgotPasswordPage from "@/pages/forgot-password.page";
import SendLoginLinkPage from "@/pages/send-login-link.page";

import { ifAuthenticated, ifNotAuthenticated } from "./auth";

const routes = [
  {
    name: "home",
    path: "/",
    component: HomePage,
    beforeEnter: ifAuthenticated,
  },
  {
    name: "resources",
    path: "/resources",
    component: ResourcesPage,
    beforeEnter: ifAuthenticated,
  },
  {
    name: "networking",
    path: "/networking",
    component: NetworkingPage,
    beforeEnter: ifAuthenticated,
  },
  {
    name: "signup",
    path: "/sign-up",
    component: SignUpPage,
    beforeEnter: ifAuthenticated,
  },
  {
    name: "signup-thanks",
    path: "/sign-up-thanks",
    component: SignUpThanksPage,
    beforeEnter: ifAuthenticated,
  },
  {
    name: "stories",
    path: "/stories",
    component: MemoriesPage,
    beforeEnter: ifAuthenticated,
  },
  {
    name: "agenda",
    path: "/agenda",
    component: AgendaPage,
    beforeEnter: ifAuthenticated,
  },
  {
    name: "socials",
    path: "/socials",
    component: SocialsPage,
    beforeEnter: ifAuthenticated,
  },
  {
    name: "article",
    path: "/article/:id-:title",
    component: ArticlePage,
  },
  {
    name: "chat-test",
    path: "/chat-test",
    component: ChatTestPage,
    beforeEnter: ifAuthenticated,
  },
  {
    name: "login",
    path: "/login",
    component: LoginPage,
    beforeEnter: ifNotAuthenticated,
  },
  {
    name: "authenticate",
    path: "/authenticate",
    beforeEnter(to) {
      localStorage.setItem("token", to.query.token);
    },
  },
  {
    name: "forgotPassword",
    path: "/forgot-password/",
    component: ForgotPasswordPage,
  },
  {
    name: "oneClickAuth",
    path: "/auth/one_click_auth/:one_click_auth_token",
    beforeEnter(to, from, next) {
      const { one_click_auth_token } = to.params;
      Vue.prototype.$api.Auth.oneClickAuth({ one_click_auth_token }).then(
        (res) => {
          localStorage.setItem("token", res.data.token);
          next("/");
        }
      );
    },
  },
  {
    name: "sendLoginLink",
    path: "/send-login-link/",
    component: SendLoginLinkPage,
  },
  {
    name: "confirmEmail",
    path: "/confirm/:confirmation_token",
    beforeEnter(to, from, next) {
      const { confirmation_token } = to.params;
      Vue.prototype.$api.Auth.oneClickAuth({ confirmation_token }).then(
        (res) => {
          localStorage.setItem("token", res.data.token);
          next("/");
        }
      );
    },
  },
  {
    name: "chat-index",
    path: "/chat",
    component: ChatIndexPage,
    beforeEnter: ifAuthenticated,
  },
  {
    name: "chat-hub",
    path: "/:slug",
    component: ChatHubPage,
    beforeEnter: ifAuthenticated,
  },
];

export default routes;
